/**
 * invoiceConfig.js — Flywell company details printed on invoices.
 *
 * EASY EDIT: change values here and the invoice updates immediately.
 *
 * These are the DEFAULTS. When a super admin has saved Invoice Settings
 * from the admin panel (stored in the backend), those saved values
 * override these — field by field, only where the saved field is
 * non-empty. If the backend is unreachable, these defaults are used
 * exactly as written below.
 *
 * Leave PAN and bank fields empty to hide those blocks on the invoice.
 */
export const DEFAULT_INVOICE_SETTINGS = {
  // Company
  companyName: 'Flywell Logistics Pvt. Ltd.',
  website: 'flywelllogistics.com',
  email: 'support@flywelllogistics.com',
  // Registered address
  address: 'Badarpur, New Delhi, Delhi – 110044, India',
  state: 'Delhi',
  stateCode: '07',
  // Contact
  phone: '+91 93113 98493',
  // Tax IDs
  gstin: '07KVFPS0396D1Z8',
  pan: '',
  cin: 'U63000DL2022PTC400000',
  // Bank details (invoice shows a bank box only when accountNumber is set)
  bankName: '',
  accountHolder: '',
  accountNumber: '',
  ifsc: '',
  upi: '',
  branch: '',
  // Small note shown near the invoice footer
  termsNote: ''
};
